import { toNumber } from "./ToNumber";

export function calcularTotalRecibo(receipt) {
  const tarjetas = receipt.tarjetas ?? [];
  const instrumentos = receipt.instrumentos ?? [];
  const retenciones = receipt.retenciones ?? {};
  const iibb = retenciones.retencionesIIBB ?? [];
  const totalTarjetas = tarjetas.reduce(
    (acc, t) => acc + toNumber(t.importe),
    0,
  );
  const totalInstrumentos = instrumentos.reduce(
    (acc, i) => acc + toNumber(i.importe),
    0,
  );
  const totalIIBB = iibb.reduce((acc, iibb) => acc + toNumber(iibb.importe), 0);
  const totalEfectivo = toNumber(receipt.recibo?.efectivo);

  const totalRetenciones =
    toNumber(retenciones.retSuss) +
    toNumber(retenciones.retGanancias) +
    toNumber(retenciones.retIva) +
    toNumber(retenciones.retDrei);

  return (
    totalEfectivo +
    totalIIBB +
    totalInstrumentos +
    totalRetenciones +
    totalTarjetas
  );
}
